import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { StickyNavModule } from 'ng2-sticky-nav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountUpModule } from 'ngx-countup';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { AccordionModule } from "ngx-accordion";
import {TabsModule} from 'ngx-tabset';
import { TooltipModule } from 'ng2-tooltip-directive';
import { ParticlesModule } from 'ngx-particle';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeOneComponent } from './components/BydBatteryBox/home-one.component';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { WelcomeComponent } from './components/common/welcome/welcome.component';
import { WhoWeAreComponent } from './components/common/who-we-are/who-we-are.component';
import { CtaComponent } from './components/common/cta/cta.component';
import { FunfactsComponent } from './components/common/funfacts/funfacts.component';
import { HowWeWorkComponent } from './components/common/how-we-work/how-we-work.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { BlogComponent } from './components/common/blog/blog.component';
import { FeedbackComponent } from './components/common/feedback/feedback.component';
import { FaqComponent } from './components/common/faq/faq.component';
import { WorkComponent } from './components/common/work/work.component';
import { WhyWeDifferentComponent } from './components/common/why-we-different/why-we-different.component';
import { ContactComponent } from './components/common/contact/contact.component';
import { HomeTwoComponent } from './components/RaiOn/home-two.component';
import { HomeThreeComponent } from './components/AboutUs/home-three.component';
import { HomeFourComponent } from './components/home-four/home-four.component';
import { HomeFiveComponent } from './components/WhereToBuy/home-five.component';
import { HomeSixComponent } from './components/Contact/home-six.component';
import { HomeSevenComponent } from './components/Home/home-seven.component';
import { HomeEightComponent } from './components/Download/home-eight.component';
import { HomeNineComponent } from './components/OnlineServiceCenter/home-nine.component';
import { HomeElevenComponent } from './components/home-eleven/home-eleven.component';
import { HomeTwelveComponent } from './components/home-twelve/home-twelve.component';
import { HomeThirteenComponent } from './components/home-thirteen/home-thirteen.component';
import { BlogDetailsComponent } from './components/blog-details/blog-details.component';
import { DemoSidebarComponent } from './components/common/demo-sidebar/demo-sidebar.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps'
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';



import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { PoliticasComponent } from './components/politicas/politicas.component';
import { LocalizePipe } from './pipes/localize.pipe';


export class TraduccionLoader implements TranslateLoader {

    constructor(private http: HttpClient,private translate: TranslateService) {
      translate.addLangs(['en', 'es','de','it','fr','po','ro']);
      translate.setDefaultLang('en');
    }
    switchToSpanish() {
      this.translate.use('es');
    }
    switchToDeuch() {
      this.translate.use('de');
    }
    switchToIt() {
      this.translate.use('it');
    }
    switchToFr() {
      this.translate.use('fr');
    }
    
  
    public getTranslation(lang: String): Observable<any> {
      return this.http.get(`https://api.nerva.eco/method/traducciones?codigo=${lang}`).pipe(map(
        (data) => {
          let res = {}
          data['data'].forEach(function (value) {
            //console.log(value);
            res[value.texto] = value.texto_traducido;
          });
          //console.log(res);
          return res;
        }
      ));
  
    }
  }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}


@NgModule({
    declarations: [
        AppComponent,
        HomeOneComponent,
        NavbarComponent,
        WelcomeComponent,
        WhoWeAreComponent,
        CtaComponent,
        FunfactsComponent,
        HowWeWorkComponent,
        FooterComponent,
        BlogComponent,
        FeedbackComponent,
        FaqComponent,
        WorkComponent,
        WhyWeDifferentComponent,
        ContactComponent,
        HomeTwoComponent,
        HomeThreeComponent,
        HomeFourComponent,
        HomeFiveComponent,
        HomeSixComponent,
        HomeSevenComponent,
        HomeEightComponent,
        HomeNineComponent,
        HomeElevenComponent,
        HomeTwelveComponent,
        HomeThirteenComponent,
        BlogDetailsComponent,
        DemoSidebarComponent,
        PoliticasComponent,
        LocalizePipe,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        StickyNavModule,
        BrowserAnimationsModule,
        NgxSmartModalModule.forRoot(),
        NgxScrollTopModule,
        CarouselModule,
        FormsModule,
        AccordionModule,
        CountUpModule,
        TabsModule,
        TooltipModule,
        NgxTypedJsModule,
        ParticlesModule,
        CollapseModule.forRoot(),
        ReactiveFormsModule,
        HttpClientModule,
        GoogleMapsModule,
        BrowserModule,
        HttpClientModule,
        TranslateModule.forRoot({
          defaultLanguage: 'en',
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        })
    ],
    providers: [],
    bootstrap: [AppComponent],
    exports: [
        TranslateModule
    ]

})
export class AppModule { }